(function () {
  'use strict';

  if (window.FriocellCartExtrasReconcileLoaded) {
    return;
  }

  window.FriocellCartExtrasReconcileLoaded = true;

  var config = window.FriocellCartExtrasReconcileConfig || {};

  var VARIANTS = {
    baseC5: Number(config.baseC5VariantId || 46337920336069),
    baseC6: Number(config.baseC6VariantId || 46337920368837),
    equipoC: Number(config.equipoVariantId || 46627393077445),
    equipoG: Number(config.equipoVariantId || 46627393044677)

  };

 var EXTRA_VARIANT_IDS = [
    VARIANTS.baseC5,
    VARIANTS.baseC6,
    VARIANTS.equipoC,
    VARIANTS.equipoG
  ];
  var isProcessing = false;
  var fallbackTimer = null;

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isExtraVariant(variantId) {
    return EXTRA_VARIANT_IDS.indexOf(Number(variantId)) !== -1;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('No se pudo leer el carrito.');
      }

      return response.json();
    });
  }

  function updateCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (errorData) {
          throw errorData;
        });
      }

      return response.json();
    });
  }

  function addItems(items) {
    if (!items.length) {
      return Promise.resolve(null);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (errorData) {
          throw errorData;
        });
      }

      return response.json();
    });
  }

  function getOptionValue(item, optionName, fallbackIndex) {
    var normalizedOptionName = normalizeText(optionName);

    if (Array.isArray(item.options_with_values)) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        if (normalizeText(item.options_with_values[i].name) === normalizedOptionName) {
          return item.options_with_values[i].value || '';
        }
      }
    }

    if (Array.isArray(item.variant_options) && item.variant_options[fallbackIndex] != null) {
      return item.variant_options[fallbackIndex];
    }

    return '';
  }

  function isArmadoRapidoMainItem(item) {
    if (!item || isExtraVariant(item.variant_id)) {
      return false;
    }

    var handle = normalizeText(item.handle);
    var productTitle = normalizeText(item.product_title);
    var title = normalizeText(item.title);

    return (
      handle.indexOf('armado-rapido') !== -1 ||
      productTitle.indexOf('armado rapido') !== -1 ||
      title.indexOf('armado rapido') !== -1
    );
  }

  function computeWantedExtras(cart) {
    var wanted = {};
    wanted[VARIANTS.baseC5] = 0;
    wanted[VARIANTS.baseC6] = 0;
    wanted[VARIANTS.equipoC] = 0;
    wanted[VARIANTS.equipoG] = 0;

    cart.items.forEach(function (item) {
      if (!isArmadoRapidoMainItem(item)) {
        return;
      }

      var modelo = normalizeText(getOptionValue(item, 'Modelo', 0));
      var equipo = normalizeText(getOptionValue(item, 'Equipo', 1));
      var quantity = Number(item.quantity || 0);

      if (modelo.indexOf('c5') !== -1) {
        wanted[VARIANTS.baseC5] += quantity;
      }

      if (modelo.indexOf('c6') !== -1) {
        wanted[VARIANTS.baseC6] += quantity;
      }

      if (equipo.indexOf('con equipo') !== -1) {
        switch (true) {
          case modelo.indexOf('c1') !== -1:
          case modelo.indexOf('c2') !== -1:
          case modelo.indexOf('c3') !== -1:
            wanted[VARIANTS.equipoC] += quantity;
            break;

          case modelo.indexOf('c4') !== -1:
          case modelo.indexOf('c5') !== -1:
          case modelo.indexOf('c6') !== -1:
            wanted[VARIANTS.equipoG] += quantity;
            break;
        }
      }
    });

    return wanted;
  }

  function groupCurrentExtras(cart) {
    var groups = {};
    EXTRA_VARIANT_IDS.forEach(function (variantId) {
      groups[variantId] = [];
    });

    cart.items.forEach(function (item) {
      var variantId = Number(item.variant_id);

      if (isExtraVariant(variantId)) {
        groups[variantId].push(item);
      }
    });

    return groups;
  }

  function buildSyncPlan(cart, wanted) {
    var groups = groupCurrentExtras(cart);
    var updates = {};
    var additions = [];

    EXTRA_VARIANT_IDS.forEach(function (variantId) {
      var desiredQuantity = Number(wanted[variantId] || 0);
      var lines = groups[variantId] || [];

      if (!lines.length) {
        if (desiredQuantity > 0) {
          additions.push({
            id: variantId,
            quantity: desiredQuantity,
            properties: {
              _friocell_component: 'true',
              _friocell_managed: 'true'
            }
          });
        }

        return;
      }

      lines.forEach(function (line, index) {
        var targetQuantity = index === 0 ? desiredQuantity : 0;

        if (Number(line.quantity || 0) !== targetQuantity) {
          updates[line.key] = targetQuantity;
        }
      });
    });

    return {
      updates: updates,
      additions: additions
    };
  }

  function hasObjectKeys(object) {
    return Object.keys(object).length > 0;
  }

  function simulateCartWithLineQuantity(cart, lineKey, newQuantity) {
    var clonedCart = JSON.parse(JSON.stringify(cart));

    clonedCart.items = clonedCart.items
      .map(function (item) {
        if (item.key === lineKey) {
          item.quantity = Number(newQuantity || 0);
        }

        return item;
      })
      .filter(function (item) {
        return Number(item.quantity || 0) > 0;
      });

    return clonedCart;
  }

  function refreshCartView() {
    if (window.location.pathname.indexOf('/cart') !== -1) {
      window.location.reload();
      return;
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function runSyncPlan(plan, shouldRefresh) {
    var chain = Promise.resolve();

    if (hasObjectKeys(plan.updates)) {
      chain = chain.then(function () {
        return updateCart(plan.updates);
      });
    }

    if (plan.additions.length) {
      chain = chain.then(function () {
        return addItems(plan.additions);
      });
    }

    return chain.then(function () {
      if (shouldRefresh) {
        refreshCartView();
      }
    });
  }

  function reconcileCart(shouldRefresh) {
    if (isProcessing) {
      return Promise.resolve(false);
    }

    isProcessing = true;

    return fetchCart()
      .then(function (cart) {
        var wanted = computeWantedExtras(cart);
        var plan = buildSyncPlan(cart, wanted);

        if (!hasObjectKeys(plan.updates) && !plan.additions.length) {
          return false;
        }

        return runSyncPlan(plan, shouldRefresh !== false).then(function () {
          return true;
        });
      })
      .catch(function (error) {
        console.error('[Friocell] Error sincronizando componentes incluidos:', error);
        return false;
      })
      .finally(function () {
        isProcessing = false;
      });
  }

  function updateMainLineAndComponents(lineKey, newQuantity) {
    if (isProcessing) {
      return;
    }

    isProcessing = true;

    fetchCart()
      .then(function (cart) {
        var simulatedCart = simulateCartWithLineQuantity(cart, lineKey, newQuantity);
        var wanted = computeWantedExtras(simulatedCart);
        var plan = buildSyncPlan(cart, wanted);

        plan.updates[lineKey] = Number(newQuantity || 0);

        return runSyncPlan(plan, true);
      })
      .catch(function (error) {
        console.error('[Friocell] Error actualizando cámara y componentes incluidos:', error);
        alert('No se pudo actualizar el carrito correctamente. Intenta nuevamente.');
      })
      .finally(function () {
        isProcessing = false;
      });
  }

  function getCartLineElement(target) {
    return target.closest('[data-friocell-cart-line]');
  }

  function getNewQuantity(target) {
    if (target.classList.contains('quantity-selector__value')) {
      return Number(target.value || 0);
    }

    if (target.classList.contains('line-item__quantity-remove') || target.classList.contains('mini-cart__quantity-remove')) {
      return 0;
    }

    if (target.hasAttribute('data-quantity')) {
      return Number(target.getAttribute('data-quantity') || 0);
    }

    return null;
  }

  function bindQuantityControls() {
    document.addEventListener('click', function (event) {
      var target = event.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"], .line-item__quantity-remove, .mini-cart__quantity-remove');

      if (!target) {
        return;
      }

      var lineElement = getCartLineElement(target);

      if (!lineElement) {
        return;
      }

      if (lineElement.dataset.friocellLogisticComponent === 'true') {
        event.preventDefault();
        event.stopPropagation();

        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        return;
      }

      if (lineElement.dataset.friocellArmadoMain !== 'true') {
        return;
      }

      var lineKey = lineElement.dataset.lineKey;
      var newQuantity = getNewQuantity(target);

      if (!lineKey || newQuantity === null) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      updateMainLineAndComponents(lineKey, newQuantity);
    }, true);

    document.addEventListener('change', function (event) {
      var target = event.target;

      if (!target.matches('.quantity-selector__value')) {
        return;
      }

      var lineElement = getCartLineElement(target);

      if (!lineElement || lineElement.dataset.friocellArmadoMain !== 'true') {
        return;
      }

      var lineKey = lineElement.dataset.lineKey;
      var newQuantity = getNewQuantity(target);

      if (!lineKey || newQuantity === null) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      updateMainLineAndComponents(lineKey, newQuantity);
    }, true);
  }

  function bindFallbackCartEvents() {
    document.addEventListener('cart:updated', function () {
      clearTimeout(fallbackTimer);
      fallbackTimer = setTimeout(function () {
        reconcileCart(false);
      }, 300);
    });
  }

  function bindCheckoutProtection() {
    document.addEventListener('submit', function (event) {
      var submitter = event.submitter;

      if (!submitter || submitter.name !== 'checkout') {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      reconcileCart(false).then(function () {
        window.location.href = '/checkout';
      });
    }, true);
  }

  function init() {
    bindQuantityControls();
    bindFallbackCartEvents();
    bindCheckoutProtection();
    reconcileCart(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
